import { BaseSectionProps } from "../types/landingSections";

import {
  Phone,
  Mail,
  Sparkles,
  ShieldCheck,
} from "lucide-react";

import { FaWhatsapp } from "react-icons/fa";

const FooterSection: React.FC<BaseSectionProps> = ({
  data,
}) => {
  const companyName =
    data?.company?.name ??
    "Profesional";

  /* CONTACTO LINKSERVS */
  const phone =
    "925004105";

  const whatsapp =
    "34671562558";

  const email =
    "linkservs@linkservs.com";

  return (
    <footer className="relative mt-32 overflow-hidden ">

      {/* Glow background */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top,rgba(0,255,255,0.08),transparent_55%)] " />

      <div className="relative max-w-7xl mx-auto px-6 py-20">

        <div
          className="
            rounded-[40px]
            border border-white/10
            bg-white/[0.03]
            backdrop-blur-2xl
            p-10 md:p-14
            shadow-sm shadow-cyan-300
          "
        >

          {/* HEADER */}
          <div className="text-center max-w-3xl mx-auto">

            <div
              className="
                inline-flex items-center gap-2
                px-4 py-2 mb-6
                rounded-full
                border border-cyan-500/20
                bg-cyan-500/10
                text-cyan-300 text-sm
              "
            >
              <Sparkles size={16} />
              Espacio digital profesional
            </div>

            <h2 className="text-3xl md:text-5xl font-bold tracking-tight text-white">
              Impulsado por{" "}
              <span className="text-cyan-400">
                LinkServs
              </span>
            </h2>

            <p className="text-white/60 mt-5 text-lg leading-relaxed">
              Este espacio digital ha sido
              cedido por{" "}
              <span className="text-cyan-300 font-medium">
                LinkServs
              </span>{" "}
              a{" "}
              <span className="text-white font-semibold">
                {companyName}
              </span>
              , proporcionando una presencia
              online moderna, profesional y
              optimizada.
            </p>
          </div>

          {/* CONTACTO */}
          <div className="mt-12 flex flex-wrap justify-center gap-4">

            {/* TELÉFONO */}
            <a
              href={`tel:${phone}`}
              className="
                inline-flex items-center gap-3
                px-6 py-4 rounded-2xl
                border border-white/10
                bg-cyan-500/10
                hover:bg-cyan-500/20
                transition-all
                hover:scale-105
              "
            >
              <Phone
                size={18}
                className="text-cyan-400"
              />

              <span className="text-white/90">
                925 004 105
              </span>
            </a>

            {/* EMAIL */}
            <a
              href={`mailto:${email}`}
              className="
                inline-flex items-center gap-3
                px-6 py-4 rounded-2xl
                border border-white/10
                bg-pink-500/10
                hover:bg-pink-500/20
                transition-all
                hover:scale-105
              "
            >
              <Mail
                size={18}
                className="text-cyan-400"
              />

              <span className="text-white/90">
                {email}
              </span>
            </a>

            {/* WHATSAPP */}
            <a
              href={`https://wa.me/${whatsapp}`}
              target="_blank"
              rel="noreferrer"
              className="
                inline-flex items-center gap-3
                px-6 py-4 rounded-2xl
                border border-green-500/20
                bg-green-500/10
                hover:bg-green-500/20
                transition-all
                hover:scale-105
              "
            >
              <FaWhatsapp
                size={18}
                className="text-green-400"
              />

              <span className="text-white/90">
                WhatsApp
              </span>
            </a>
          </div>

          {/* FOOTER */}
          <div
            className="
              mt-14 pt-8
              border-t border-white/10
              flex flex-col md:flex-row
              items-center justify-between
              gap-4
            "
          >
            <div className="flex items-center gap-2 text-white/50 text-sm">
              <ShieldCheck
                size={16}
                className="text-cyan-400"
              />
              Tecnología y espacio ofrecido
              por LinkServs
            </div>

            <p className="text-white/40 text-sm text-center md:text-right">
              © {new Date().getFullYear()}{" "}
              LinkServs · Todos los derechos
              reservados
            </p>
          </div>

        </div>
      </div>
    </footer>
  );
};

export default FooterSection;